export default function promiseTimeout(delay: number) {
    return new Promise(resolve => {
        setTimeout(resolve, delay);
    });
}
